const dashboard = () => import(/* webpackPrefetch: true */ '@/views/private/index.vue')
const dashboard_sentana = () => import(/* webpackPrefetch: true */ '@/views/private/dashboard-sentana/index.vue')

const profile = () => import(/* webpackPrefetch: true */ '@/views/private/profile/index.vue')

const unit = () => import(/* webpackPrefetch: true */ '@/views/private/unit/index.vue')

const officer = () => import(/* webpackPrefetch: true */ '@/views/private/officer/index.vue')
const officer_detail = () => import(/* webpackPrefetch: true */ '@/views/private/officer/_id.vue')
const officer_add = () => import(/* webpackPrefetch: true */ '@/views/private/officer/form/add.vue')
const officer_edit = () => import(/* webpackPrefetch: true */ '@/views/private/officer/form/edit.vue')

const sentana = () => import(/* webpackPrefetch: true */ '@/views/private/sentana/index.vue')
const sentana_detail = () => import(/* webpackPrefetch: true */ '@/views/private/sentana/_id.vue')
const sentana_add = () => import(/* webpackPrefetch: true */ '@/views/private/sentana/form/add.vue')
const sentana_edit = () => import(/* webpackPrefetch: true */ '@/views/private/sentana/form/edit.vue')

const report = () => import(/* webpackPrefetch: true */ '@/views/private/report/index.vue')
const audit = () => import(/* webpackPrefetch: true */ '@/views/private/audit/index.vue')
const setting = () => import(/* webpackPrefetch: true */ '@/views/private/setting/index.vue')

const trah = () => import(/* webpackPrefetch: true */ '@/views/private/trah.vue')
const data_trah = () => import(/* webpackPrefetch: true */ '@/views/private/trah/data/index.vue')
const status_trah = () => import(/* webpackPrefetch: true */ '@/views/private/trah/status/index.vue')

const hak_akses = () => import(/* webpackPrefetch: true */ '@/views/private/hak-akses/index.vue')

const hak_akses_user = () => import(/* webpackPrefetch: true */ '@/views/private/hak-akses-user/index.vue')

const contact = () => import(/* webpackPrefetch: true */ '@/views/private/contact/index.vue')

const group = () => import(/* webpackPrefetch: true */ '@/views/private/group/index.vue')

const pesan = () => import(/* webpackPrefetch: true */ '@/views/private/pesan/index.vue')

const qr = () => import(/* webpackPrefetch: true */ '@/views/private/qr-image/index.vue')

const kop_undangan = () => import(/* webpackPrefetch: true */ '@/views/private/kop-undangan/index.vue')

const undangan = () => import(/* webpackPrefetch: true */ '@/views/private/undangan/index.vue')

const kepaniteraan = () => import(/* webpackPrefetch: true */ '@/views/private/kepaniteraan/index.vue')

const routes = [
  {
    path: "/dashboard",
    name: "Dashboard",
    component: dashboard,
    meta: {
      title: "Dashboard"
    }
  },

  {
    path: "/dashboard-sentana",
    name: "Dashboard Sentana",
    component: dashboard_sentana,
    meta: {
      title: "Dashboard Sentana"
    }
  },

  
  {
    path: "/profile",
    name: "Profil",
    component: profile,
    meta: {
      title: "Profil"
    }
  },


  {
    path: "/unit",
    name: "Struktur Organisasi",
    component: unit,
    meta: {
      title: "Struktur Organisasi"
    }
  },


  {
    path: "/officer",
    name: "Abdi Dalem",
    component: officer,
    meta: {
      title: "Abdi Dalem"
    }
  },
  {
    path: "/officer/:id",
    name: "Detail Abdi Dalem",
    component: officer_detail,
    meta: {
      title: "Detail Abdi Dalem"
    }
  },
  {
    path: "/officer/form/add",
    name: "Tambah Abdi Dalem",
    component: officer_add,
    meta: {
      title: "Tambah Abdi Dalem"
    }
  },
  {
    path: "/officer/form/edit/:id",
    name: "Ubah Abdi Dalem",
    component: officer_edit,
    meta: {
      title: "Ubah Abdi Dalem"
    }
  },

  {
    path: "/sentana",
    name: "Sentana",
    component: sentana,
    meta: {
      title: "Sentana"
    }
  },
  {
    path: "/sentana/:id",
    name: "Detail Sentana",
    component: sentana_detail,
    meta: {
      title: "Detail Sentana"
    }
  },
  {
    path: "/sentana/form/add",
    name: "Tambah Sentana",
    component: sentana_add,
    meta: {
      title: "Tambah Sentana"
    }
  },
  {
    path: "/sentana/form/edit/:id",
    name: "Ubah Sentana",
    component: sentana_edit,
    meta: {
      title: "Ubah Sentana"
    }
  },


  {
    path: "/report",
    name: "Pencatatan",
    component: report,
    meta: {
      title: "Pencatatan"
    }
  },


  {
    path: "/audit",
    name: "Audit Trail",
    component: audit,
    meta: {
      title: "Audit Trail"
    }
  },


  {
    path: "/konfigurasi/setting",
    name: "Aplikasi",
    component: setting,
    meta: {
      title: "Aplikasi"
    }
  },

  {
    path: "/konfigurasi/trah",
    name: "Trah",
    component: trah,
    children: [
      {
        path: "/konfigurasi/trah/data",
        name: "Data Trah",
        component: data_trah,
        meta: {
          title: "Data Trah"
        }
      },
      {
        path: "/konfigurasi/trah/status",
        name: "Data Status Trah",
        component: status_trah,
        meta: {
          title: "Data Status Trah"
        }
      }
    ],
    meta: {
      title: "Trah"
    }
  },

  {
    path: "/konfigurasi/hak-akses",
    name: "Hak Akses",
    component: hak_akses,
    meta: {
      title: "Hak Akses"
    }
  },

  {
    path: "/konfigurasi/hak-akses-user",
    name: "Hak Akses User",
    component: hak_akses_user,
    meta: {
      title: "Hak Akses User"
    }
  },

  {
    path: "/pesan/kontak",
    name: "Kontak",
    component: contact,
    meta: {
      title: "Kontak"
    }
  },

  {
    path: "/pesan/grup",
    name: "Grup",
    component: group,
    meta: {
      title: "Grup"
    }
  },

  {
    path: "/pesan/data",
    name: "Data Pesan",
    component: pesan,
    meta: {
      title: "Data Pesan"
    }
  }, 

  {
    path: "/pesan/qr",
    name: "QR Image",
    component: qr,
    meta: {
      title: "QR Image"
    }
  }, 

  {
    path: "/undangan/kop",
    name: "Kop Undangan",
    component: kop_undangan,
    meta: {
      title: "Kop Undangan"
    }
  },

  {
    path: "/undangan/data",
    name: "Data Undangan",
    component: undangan,
    meta: {
      title: "Data Undangan"
    }
  },

  {
    path: "/undangan/kepaniteraan",
    name: "Data Kawedanan Undangan",
    component: kepaniteraan,
    meta: {
      title: "Data Kawedanan Undangan"
    }
  }
]

export default routes.map(route => {
  const meta = {
    all: false, 
    public: false,
    title: route.meta.title
  }
  return { ...route, meta }
})